import React, { Component } from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import ModalRequestADemo from '../modalRequestADemo/ModalRequestADemo';

class ScheduleADemoSection extends Component {
  render() {
    return (
      <div className="subscribeNoctil bg-gradient">
        <div className="container">
          <div className="row">
            <div className="col-lg-9">
              <ScrollAnimation animateIn="fadeInUp" animateOnce={true} delay={50}>
                <h2>
                  Are You Ready for the Evolving Music Industry? <br />
                  <b>Take the Best Step Forward with Noctil!</b>
                </h2>
              </ScrollAnimation>
            </div>
            <div className="col-lg-3 d-flex align-items-center mt--20">
              <ScrollAnimation animateIn="fadeInUp" animateOnce={true} delay={50}>
                <ModalRequestADemo />
              </ScrollAnimation>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default ScheduleADemoSection;
